import { make } from 'vuex-pathify'
import dottie from 'dottie'
import { api } from '@/api'

const state = {
  firm: {}
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state),

  created(state, { firm }) {
    state.firm = firm
  },

  creationFailed() {},

  read(state, { firm }) {
    state.firm = firm
  },

  readFailed(state) {
    state.firm = {}
  },

  updated(state, { firm }) {
    state.firm = firm
  },

  updateFailed() {},

  deleted(state) {
    state.firm = {}
  },

  deleteFailed() {},

  reseted(state) {
    state.firm = {}
  }
}

const actions = {
  async reset({ commit }) {
    commit('reseted')
  },

  async create({ commit }, data) {
    try {
      const response = await api.put('/firms', state.firm)
      const firm = dottie.get(response, 'data.firm', null)
      commit('created', { firm })
    } catch (e) {
      commit('creationFailed')
    }
  },

  async read({ state, commit }, id) {
    try {
      const response = await api.get(`/firms/${id}`)
      const firm = dottie.get(response, 'data.firm', null)
      commit('read', { firm })
    } catch (e) {
      commit('readFailed')
    }
  },

  async update({ state, commit }) {
    try {
      const response = await api.put(`/firms/${state.firm._id}`, state.firm)
      const firm = dottie.get(response, 'data.firm', null)
      commit('updated', { firm })
    } catch (e) {
      commit('updateFailed')
    }
  },

  async delete({ state, commit }) {
    try {
      const response = await api.delete(`/firms/${state.firm._id}`)
      if (response.status === 200) commit('deleted')
    } catch (e) {
      commit('deleteFailed')
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
